import {createTableState} from '@/core/services/Helper'

const state = () => ({
    table: createTableState(),
    filterData: undefined
})

// getters
const getters = {}

// actions
const actions = {
    // get records
    // NOT: Ürün grubu listesi tek seferde döner ve pagination meta'sı yoktur.
    async get({state, commit}, {filterData} = {}) {
        commit('setLoading', true)

        state.filterData = filterData;

        let params = {};

        if (state.filterData) {
            params = {...params, ...state.filterData};
        }

        const res = await this._vm.axios.get(this._vm.endpoint.get('ecommerce_product_group'), {
            params: params
        })

        commit('updateTableData', res.data.data)

        setTimeout(() => {
            commit('setLoading', false)
        }, 250)
    },

    // refresh records
    refresh({state, dispatch}) {
        dispatch('get', {
            filterData: state.filterData
        })
    },

    // show record
    async show({commit, dispatch}, {id}) {
        const response = await this._vm.axios.get(this._vm.endpoint.get('ecommerce_product_group') + '/' + id)
        return response.data.data
    },

    // add record
    async create({commit, dispatch}, {data}) {
        let payloadData = {
            ...data.data,
            ...data.translate
        }
        const response = await this._vm.axios.post(this._vm.endpoint.get('ecommerce_product_group') + '/', payloadData)
        return response.data
    },

    // update record
    async put({commit, dispatch}, {id, data}) {
        let payloadData = {
            ...data.data,
            ...data.translate
        }
        const response = await this._vm.axios.put(this._vm.endpoint.get('ecommerce_product_group') + '/' + id, payloadData)
        return response.data
    },

    //  delete record
    async delete({commit, dispatch}, {id}) {
        let successDeleted = [];
        if (id.length === 0) {
            this._vm.$message.warning(this._vm.$t('messages.selectRow'))
        } else {
            for (let i = 0; i < id.length; i++) {
                const {data} = await this._vm.axios.delete(this._vm.endpoint.get('ecommerce_product_group') + '/' + id[i]);
                if (data.status) {
                    this._vm.$message.success(this._vm.$t('messages.deleteOk'));
                    successDeleted.push(id[i]);
                } else {
                    this._vm.$message.error(data.message)
                }
            }

            dispatch('refresh')

            return successDeleted;
        }
    },
}

// mutations
const mutations = {
    setLoading(state, val) {
        state.table.loading = val
    },
    updatePagination(state, pagination) {
        state.table.pagination = pagination
    },
    updateTableData(state, data) {
        state.table.data = data
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
